

import React from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
interface ConfirmCloseModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}
const ConfirmCloseModal: React.FC<ConfirmCloseModalProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  // Preload image on mount
  React.useEffect(() => {
    const img = new Image();
    img.src = "https://21180823.fs1.hubspotusercontent-na1.net/hubfs/21180823/16b43907-6361-4531-bcfd-9cf8d7a4f70b.png";
  }, []);

  return <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="max-w-md" style={{
      zIndex: 200000
    }}>
        <div className="mb-4 text-center">
          <img src="https://21180823.fs1.hubspotusercontent-na1.net/hubfs/21180823/16b43907-6361-4531-bcfd-9cf8d7a4f70b.png" alt="Propositions personnalisées" className="w-3/4 mx-auto rounded-lg" />
        </div>
        
        <AlertDialogHeader>
          <AlertDialogTitle className="font-normal text-center text-3xl py-[21px]">Une dernière étape pour vos suggestions sur-mesure</AlertDialogTitle>
        </AlertDialogHeader>

        <AlertDialogFooter className="flex flex-col gap-3 items-center justify-center w-full">
          <AlertDialogAction onClick={onClose} className="w-full max-w-xs bg-cta-green hover:bg-cta-green/90 text-cta-green-foreground rounded-xl py-3 mx-auto">
            Compléter la dernière étape
          </AlertDialogAction>
        </AlertDialogFooter>
        
        <div className="flex justify-center pb-4">
          <AlertDialogCancel onClick={onConfirm} className="w-full max-w-xs border-none bg-transparent hover:bg-transparent text-gray-500 hover:text-gray-700 mt-0 mx-auto">
            Fermer sans compléter
          </AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>;
};
export default ConfirmCloseModal;

